import { render, staticRenderFns } from "./AuthorStatusPicker.vue?vue&type=template&id=c1f01490&"
import script from "./AuthorStatusPicker.vue?vue&type=script&lang=js&"
export * from "./AuthorStatusPicker.vue?vue&type=script&lang=js&"
import style0 from "./AuthorStatusPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports